import React from 'react';
import Image from 'next/image';
import { JobDetail } from '~/types/job-detail';

interface JobImageProps {
  job: JobDetail;
}

export function JobImage(props: JobImageProps) {
  const { job } = props;
  const sampleImageUrl = `/nextjs/images/sample_images/image${
    (job.id % 9) + 1
  }_small.webp`;

  // 存在チェック用（Rails の存在判定に準じる）
  const hasW600 = job.image?.w600?.file?.exists;
  const hasThumb = job.image?.thumb?.file?.exists;

  // alt テキストの切り替え用関数
  const getAltText = (defaultAlt: string) =>
    job.display_company_info ? job.title || defaultAlt : defaultAlt;

  // 画像レンダリング部分（共通のサイズ等）
  const renderImg = (loadingAttr = {}) => {
    if (hasW600) {
      return (
        <Image
          src={job.image.w600.url}
          alt={getAltText('求人の画像')}
          width={300}
          height={200}
          {...loadingAttr}
          style={{ maxWidth: 'none', height: '200px' }}
          className="p-job-detail__image"
          unoptimized
        />
      );
    } else if (hasThumb) {
      return (
        <Image
          src={job.image.thumb.url}
          alt={getAltText('求人の画像')}
          width={300}
          height={200}
          {...loadingAttr}
          style={{ maxWidth: 'none', height: '200px' }}
          className="p-job-detail__image"
          unoptimized
        />
      );
    } else {
      return (
        <Image
          src={job.image_url_text}
          alt={getAltText('求人の画像')}
          width={300}
          height={200}
          {...loadingAttr}
          layout="fixed"
          style={{ maxWidth: 'none', height: '200px' }}
          className="p-job-detail__image"
          unoptimized
        />
      );
    }
  };

  // picture 内での source タグ
  const renderSource = () => {
    // job.image_url が null または undefined の場合に sampleImageUrl を表示
    if (job.image_url == null) {
      // display_company_info が true の場合は alt 属性付き、そうでなければ alt 属性無し
      const sourceProps = {
        srcSet: sampleImageUrl,
        type: 'image/webp',
        ...(job.display_company_info && { alt: job.title }),
      };
      return <source {...sourceProps} />;
    }
    return null;
  };

  // service_typeが求人広告 の場合は画像に loading="lazy" を付与する
  const loadingProps =
    job.service_type == '求人広告' ? { loading: 'lazy' } : {};

  return (
    <div>
      <picture>
        {renderSource()}
        {renderImg(loadingProps)}
      </picture>
    </div>
  );
}
